export default "__VITE_ASSET__CxaHWSWl__"